The location name, e.g. "Richmond".

This name is ambiguous without the context of its parent location.
